import { createApp } from 'vue'
import './style.css'
import App from './App.vue'

import { createPinia } from 'pinia'
import router from '@router/router'

import PrimeVuePlugin from '@services/plugins/primevue'
import ToastPlugin from '@services/plugins/toast'

import { configService } from '@services/requests/config'

import { useAuthStore } from '@stores/auth'
// Инициализация приложения
async function bootstrap() {
    
    

    const app = createApp(App)
    const pinia = createPinia()
    await app.use(pinia)


    app.provide('config', configService)

    
    app.use(router)



    //Загружаем конфиг 
    try {
        await configService.loadAppConfig()
        console.log('✅ Конфигурация загружена')
    } catch (error) {
        console.error('Oшибка загрузки конфигурации:', error)
    }

    

    app.use(PrimeVuePlugin)
    app.use(ToastPlugin)

    app.config.errorHandler = (err, vm, info) => {
        console.error('❌ Vue Error:', err)
        console.error('Info:', info)
    }

    app.config.warnHandler = (msg, vm, trace) => {
        console.warn('⚠️ Vue Warning:', msg)
    }

    app.mount('#app')
    
    
    
    console.log('🚀 Приложение запущено')

    const authStore = useAuthStore()
    authStore.checkAuth()
}



bootstrap()


window.addEventListener('unhandledrejection', (event) => {
console.error('Unhandled Promise Rejection:', event.reason)
event.preventDefault()
})

window.addEventListener('error', (event) => {
console.error('Global Error:', event.error)
})
